import type { FxWorkspace } from '@mobile-mapping/providers';
import { type Accessor, createSignal } from 'solid-js';

import type {
  WorkspacePendingDelete,
  WorkspacesTabDialogsState,
} from './useWorkspacesTabDialogs.types';

export function useWorkspacesTabDialogs(
  activeWorkspace: Accessor<FxWorkspace | undefined>
): WorkspacesTabDialogsState {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = createSignal(false);
  const [workspacePendingDelete, setWorkspacePendingDelete] = createSignal<
    WorkspacePendingDelete | undefined
  >(undefined);

  const openCreateDialog = (): void => {
    setIsCreateDialogOpen(true);
  };

  const closeCreateDialog = (): void => {
    setIsCreateDialogOpen(false);
  };

  const openDeleteDialog = (): void => {
    const workspace = activeWorkspace();
    if (workspace === undefined) {
      return;
    }

    setWorkspacePendingDelete({
      id: workspace.id,
      name: workspace.name,
    });
  };

  const closeDeleteDialog = (): void => {
    setWorkspacePendingDelete(undefined);
  };

  return {
    isCreateDialogOpen,
    workspacePendingDelete,
    openCreateDialog,
    closeCreateDialog,
    openDeleteDialog,
    closeDeleteDialog,
  };
}
